(function() {
	'use strict';

	angular.module('app.dashboard')
	.config(workbenchTaskSummaryConfig)
	.config(workbenchTaskTypeDistributionConfig)
	.config(workbenchAdjustmentDetailsConfig)
	.config(workbenchHistoricalOverdueConfig)
	.config(workbenchTopUtfReasonsConfig);


	function workbenchTaskSummaryConfig (dashboardProvider) {
		dashboardProvider.widget(
			'workbenchTaskSummary', {
				name: 'Workbench task summary',
				description: "A high-level summary of all task statuses across all types. It shows the total number of tasks that were successfully fixed, marked as 'Unable to Fix', or are still incomplete.",
				thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/workbench-task-summary.png',
				categories: ['All', 'Workbench'],
				config: {},
				slideshowView: true,
				isActive: true,
				templateUrl: '/application/f/dashboard/widgets/workbench-widget.html',
				reload: true,
				isDrillDown: true,
				isEditable: true,
				resolve: {
					breakdownType: function (config) {
						if (config.breakdownType) {
							return config.breakdownType;
						}
						return null;
					}
				}
			}
		);
	}

	function workbenchTaskTypeDistributionConfig (dashboardProvider) {
		dashboardProvider.widget(
			'workbenchTaskTypeDistribution', {
				name: 'Workbench task type distribution',
				description: 'This chart shows the breakdown of tasks by completion status (Fixed, UTF, Open, Expired) across different task types.',
				thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/workbench-task-type-distribution.png',
				categories: ['All', 'Workbench'],
				config: {},
				slideshowView: true,
				isActive: true,
				templateUrl: '/application/f/dashboard/widgets/workbench-widget.html',
				reload: true,
				isDrillDown: true,
				isEditable: false
			}
		);
	}

	function workbenchAdjustmentDetailsConfig (dashboardProvider) {
		dashboardProvider.widget(
			'workbenchAdjustmentDetails', {
				widgetId: 'workbenchAdjustmentDetails',
				name: 'Workbench adjustment status details',
				description: 'This chart shows the completion status (Fixed, UTF, Open, Expired) for different types of PO adjustments.',
				thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/workbench-adjustment-status-details.png',
				categories: ['All', 'Workbench'],
				config: {},
				slideshowView: true,
				isActive: true,
				templateUrl: '/application/f/dashboard/widgets/workbench-widget.html',
				reload: true,
				isDrillDown: true,
				isEditable: true
			}
		);
	}

	function workbenchTopUtfReasonsConfig (dashboardProvider) {
		dashboardProvider.widget(
			'workbenchTopUtfReasons', {
				widgetId: 'workbenchTopUtfReasons',
				name: 'Workbench unable to fix reasons',
				description: "This Pareto chart highlights the most frequent reasons for 'Unable to Fix' tasks, helping to identify root causes.",
				thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/workbench-utf-reasons.png',
				categories: ['All', 'Workbench'],
				config: {},
				slideshowView: true,
				isActive: true,
				templateUrl: '/application/f/dashboard/widgets/workbench-widget.html',
				reload: true,
				isDrillDown: false,
				isEditable: false
			}
		);
	}

	function workbenchHistoricalOverdueConfig (dashboardProvider) {
		dashboardProvider.widget(
			'workbenchHistoricalOverdue', {
				widgetId: 'workbenchHistoricalOverdue',
				name: 'Overdue tasks by severity',
				description: 'This widget shows the number of tasks that became overdue, categorized by how late they are.',
				thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/workbench-overdue-tasks-by-severity.png',
				categories: ['All', 'Workbench'],
				config: {},
				slideshowView: true,
				isActive: true,
				templateUrl: '/application/f/dashboard/widgets/workbench-widget.html',
				reload: true,
				isDrillDown: false,
				isEditable: false,
				resolve: {
					breakdownType: function (config) {
						if (config.breakdownType) {
							return config.breakdownType;
						}
						return null;
					}
				}
			}
		);
	}
	
})();
